import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';
import { Entity } from '../classes/entity.class';
import { PlanningHistoryEntry } from '../classes/planning-history-entry';
import { User } from '../classes/user.class';
import { EntityTypeCode } from '../services/entities/entity-type.class';

export interface SourceLabel {
    kind: 'personnel' | 'materiel' | null;
    icon: string | null;
    name: string;
    driverName: string | null;
}

@Pipe({
    name: 'sourceLabel',
    standalone: false,
})
export class SourceLabelPipe implements PipeTransform {
    transform(item: PlanningHistoryEntry, entities: Entity[], users: User[]): SourceLabel {
        if (item.source !== 'planning_has_entity') {
            return { kind: null, icon: null, name: '', driverName: null };
        }

        const entityType = environment.entitytypes[item.entitytype_key];
        const kind =
            item.entitytype_key === EntityTypeCode.InhuurPersoneel
                ? 'personnel'
                : entityType &&
                    (environment.platform !== 'trackline' || entityType.has_employees || entityType.has_driver)
                  ? 'materiel'
                  : null;

        if (!kind) {
            return { kind: null, icon: null, name: '', driverName: null };
        }

        return {
            kind,
            icon: kind === 'materiel' ? (entityType?.icon ?? null) : null,
            name: entities?.find(e => e.id === item.entity_id)?.name ?? 'Onbekend',
            driverName:
                kind === 'materiel' && item.user_id != null
                    ? (users?.find(u => u.id === item.user_id)?.name ?? 'Onbekend')
                    : null,
        };
    }
}
